import { Box, Typography } from "@mui/material";
import Button from "@mui/material/Button";
import { useTheme } from "@mui/material/styles";

import Dialog from "../ui/omniDialog";
import DialogActions from "../ui/omniDialogActions";
import DialogContent from "../ui/omniDialogContent";
import DialogMessage from "../ui/omniDialogMessage";
import DialogTitle from "../ui/omniDialogTitle";

const humanizeKey = key =>
  key
    .replace(/([A-Z])/g, " $1")
    .replace(/[_-]+/g, " ")
    .replace(/^./, character => character.toUpperCase())
    .trim();

const formatValue = value => {
  if (value == null || value === "") {
    return "—";
  }
  if (typeof value === "object") {
    return JSON.stringify(value, null, 2);
  }
  return `${value}`;
};

const BotpressHarnessUserDialog = props => {
  const {
    open,
    onClose,
    userProfile,
    userLabel = "User",
    maxWidth = "xs",
    fullWidth = true,
  } = props;

  const theme = useTheme();

  const entries = Object.entries(userProfile || {}).filter(
    ([key]) => key !== "uiLabel" && key !== "defaultUser",
  );

  return (
    <Dialog open={open} onClose={onClose} maxWidth={maxWidth} fullWidth={fullWidth}>
      <DialogTitle onClose={onClose}>{userLabel}</DialogTitle>
      <DialogContent>
        {entries.length === 0 ? (
          <DialogMessage>
            This user has no profile information. Conversations will run anonymously.
          </DialogMessage>
        ) : (
          <>
            <DialogMessage>This is the information sent to the bot for this user.</DialogMessage>
            <Box
              sx={{
                marginTop: theme.spacing(1),
                border: `1px solid ${theme.palette.divider}`,
                borderRadius: theme.spacing(1),
                overflow: "hidden",
              }}
            >
              {entries.map(([key, value], index) => (
                <Box
                  key={key}
                  sx={{
                    padding: theme.spacing(1),
                    borderBottom:
                      index < entries.length - 1 ? `1px solid ${theme.palette.divider}` : "none",
                  }}
                >
                  <Typography variant="caption" color="textSecondary">
                    {humanizeKey(key)}
                  </Typography>
                  <Typography
                    variant="body2"
                    sx={{ whiteSpace: "pre-wrap", wordBreak: "break-word" }}
                  >
                    {formatValue(value)}
                  </Typography>
                </Box>
              ))}
            </Box>
          </>
        )}
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose} color="secondary" variant="contained">
          Close
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default BotpressHarnessUserDialog;
